<!-- 
화면명 : OrderList.vue
작성일 : 2025-07-01
설명   : 주문현황 화면
-->
<template>
  <div>
    <div class="relative bg-blueGray-100">

      <div class="flex justify-between mt-2">
        <div class="flex text-black font-bold text-lg items-center justify-center">
          <img src="@/assets/img/breadcrumbs.svg" class="w-4 h-4 mx-2" />
          주문현황
        </div>
        <div class="flex mx-2">
          <UCButton label="조회"      width="80px"   icon="search"  @click="btnSearchClick" />
          <UCButton label="엑셀"      width="80px"   icon="excel"   @click="btnExcelClick" />
          <UCButton label="주문일보"   width="100px"  icon="printer" @click="btnIlboClick" />
          <UCButton label="발주서"    width="100px"  icon="printer" @click="btnMBClick"  />
        </div>
      </div>

      <div class="bg-white p-1 rounded shadow mt-2 top-wrapper">
        <div
          class="w-full overflow-x-visible inline-flex flex-wrap items-center gap-6 whitespace-nowrap px-4 py-2 border rounded bg-white shadow-sm"
        >
          <UCRadio
            label="작업구분"
            v-model="rdoGubun.cd"
            :arrData="rdoGubun.arr"
            code="value"
            name="label"
            @change="changeRadioGubun"
          />

          <div class="flex space-x-2">
            <UCDate label="발주일자" v-model="dtStart" />
            <span class="pt-2">&nbsp;~</span>
            <UCDate label="" v-model="dtEnd" />
          </div>

          <UCText label="도면번호" v-model="txtDomyunNo" width="130px" />

          <UCCombo
            label="구분"
            v-model="cboGubun.cd"
            :arrData="cboGubun.arr"
            code="CD"
            name="NAME"
            width="100px"
          />

          <div class="flex items-center space-x-2">
            <UCVendor
              title="거래선"
              :VendCd="userStore.userVendCd"
              :VendName="userStore.userName"
            />
          </div>

          <UCCombo
            label="발주구분"
            v-model="cboBaljuGubun.cd"
            :arrData="cboBaljuGubun.arr"
            code="CMCD"
            name="CMCD_NAME"
            width="190px"
          />

          <UCText label="호선" v-model="txtShipNo" width="100px" />
        </div>
      </div>

      <!-- 소계 구분 -->
      <div class="mt-2 flex justify-between items-center">
        <label class="flex text-blueGray-600 text-base font-semibold whitespace-nowrap items-center justify-center" >
          <img src="@/assets/img/icon-list.svg" class="flex w-5 h-5 mr-2" />
          발주 현황
        </label>

        <UCRadio
          label="소계구분"
          v-model="rdoSubTotalGubun.cd"
          :arrData="rdoSubTotalGubun.arr"
          code="value"
          name="label"
        />
      </div>

      <!-- 그리드 -->
      <div class="mt-2 mb-4">
        <UCGrid
          ref="refUcGrid"
          :data="arrSearchData"
          :columns="columns"
          :options="gridOptions"
          :selectable="true"
          :pagination="true"
          :paginationSize="50"
          autoHeight
          :excludeSelectors="['.top-wrapper']"
          :heightOffset="30"
          @row-selected="handleSelection"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { format as formatDate } from "date-fns";
import { notify } from "@kyvg/vue3-notification";

import { useUserStore } from "@/store/userStore";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

import UCVendor from "@/components/UserControl/UCVendor.vue";
import UCGrid from "@/components/UserControl/UCGrid.vue";
import UCText from "@/components/UserControl/UCText.vue";
import UCCombo from "@/components/UserControl/UCCombo.vue";
import UCDate from "@/components/UserControl/UCDate.vue";
import UCRadio from "@/components/UserControl/UCRadio.vue";
import UCButton from "@/components/UserControl/UCButton.vue";

import { apiExecuteDataSet, apiExecuteReport } from "@/api/SCM/common";

const userStore = useUserStore();

onMounted(() => {
  // console.log("mounted");
  bindCombo();

  btnSearchClick();
});

// 처리 구분
const rdoGubun = ref({
  cd: "M",
  arr: [
    { label: "자재", value: "M" },
    { label: "외주", value: "P" },
  ],
});

// 구분
const cboGubun = ref({
  cd: "",
  arr: [
    { NAME: "주문", CD: "" },
    { NAME: "미납", CD: "M" },
  ],
});

// 발주구분
const cboBaljuGubun = ref({
  cd: "",
  arr: [],
});

const refUcGrid = ref(null);
const txtShipNo = ref("");
const txtDomyunNo = ref("");
const dtStart = ref("");
const dtEnd = ref("");

// 소계 구분
const rdoSubTotalGubun = ref({
  cd: "TOTAL",
  arr: [
    { label: "전체", value: "TOTAL" },
    { label: "발주일자별", value: "DATE" },
    { label: "호선별", value: "WORKNO" },
    { label: "엔진타입별", value: "WORKNA" },
  ],
});

async function bindCombo() {
  // console.log("bindCombo");

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();

  const today2 = new Date(year, month, 1);
  dtStart.value = formatDate(today2, "yyyy-MM-dd");
  dtEnd.value = formatDate(today, "yyyy-MM-dd");

  const searchParams = {
    
    ID: "WERP\\T_CODE\\R002_1",
    Parameter: {
      "@COMP": "W000",
      "@BIZP": "W000",
      "@UP_CMCD": "023",
    },
  };

  const res = await Promise.all([apiExecuteDataSet(searchParams)]);
  // console.log("res", res[0]._Result);
  cboBaljuGubun.value.arr = res[0]._Result[0];
}


const arrSearchData = ref([]);
const selectedRows = ref([]);
function handleSelection(data) {
  selectedRows.value = data;
  console.log("선택된 행:", data);
}

const gridOptions = {
  selectableCheck: function (row) {
    const data = row.getData();
    const pos = data?.POS ? String(data.POS).trim() : "";
    return pos.length === 12;
  },
  rowFormatter: function (row) {
    const data = row.getData();
    const pos = data?.POS ? String(data.POS).trim() : "";
    const element = row.getElement();

    // 발주번호가 12자리가 아니면 소계 또는 총계 라인
    if (pos.length !== 12) {
      element.style.backgroundColor = "#fef9c3"; // 강조 배경색 (연한 옐로우/앰버 톤)
      element.style.fontWeight = "bold";
      element.style.color = "#0f172a";

      // 소계/총계 행의 체크박스 숨김 처리
      const chk = element.querySelector("input[type='checkbox']");
      if (chk) {
        chk.style.display = "none";
      }
    } else {
      element.style.backgroundColor = "";
      element.style.fontWeight = "";
      element.style.color = "";

      const chk = element.querySelector("input[type='checkbox']");
      if (chk) {
        chk.style.display = "";
      }
    }
  },
};

const columns = [
  // {
  //   title: "No.",
  //   //formatter: "rownum",
  //   formatter: function (cell) {
  //     const data = cell.getRow().getData();
  //     const pos = data?.POS ? String(data.POS).trim() : "";

  //     // 발주번호가 12자리가 아니면 소계/총계 라인이므로 번호 표시 안 함
  //     if (pos.length !== 12) {
  //       return "";
  //     }

  //     const table = cell.getTable();
  //     const page = table.getPage(); // 현재 페이지 정보
  //     const pageSize = table.getPageSize(); // 현재 페이지 정보
  //     const rowPosition = cell.getRow().getPosition(false); // 현재 페이지 내 위치(0부터 시작)

  //     return (page - 1) * pageSize + (rowPosition + 1 - 1);
  //   },
  //   width: 80,
  //   hozAlign: "center",
  //   frozen: true,
  // },
  {
    title: "",
    formatter: "rowSelection",
    titleFormatter: "rowSelection",
    hozAlign: "center",
    headerSort: false,
    width: 50,
    frozen: true,
  },
  {
    title: "발주번호",
    field: "POS",
    width: 120,
    hozAlign: "center",
    frozen: true,
  },
  {
    title: "행번",
    field: "M05SEQNO",
    width: 80,
    hozAlign: "center",
    frozen: true,
  },
  { title: "자재코드", field: "M05MATCD", width: 120, hozAlign: "center",
    frozen: true, },
  {
    title: "자재명",
    field: "M05MATNA",
    width: 180,
    hozAlign: "left",
    frozen: true,
  },
  {
    title: "도면번호",
    field: "M05DWGNO",
    width: 120,
    hozAlign: "left",
    frozen: true,
  },
  { title: "규격", field: "M05SIZE", width: 120, hozAlign: "left" },
  { title: "재질", field: "M05MATL", width: 120, hozAlign: "left" },
  { title: "발주", field: "M0MIPGQTY", width: 80, hozAlign: "right", formatter: "money",
    formatterParams: {
      thousand: ",",
      decimal: ".",
      precision: 0, // 소수점 자릿수 (예: 2면 100.00)
    }, },
  { title: "단가", field: "M05DANGA", width: 80, hozAlign: "right", formatter: "money",
    formatterParams: {
      thousand: ",",
      decimal: ".",
      precision: 0, // 소수점 자릿수 (예: 2면 100.00)
    }, },
  { title: "발주금액", field: "M05AMOUNT", width: 120, hozAlign: "right" 
  , formatter: "money",
    formatterParams: {
      thousand: ",",
      decimal: ".",
      precision: 0, // 소수점 자릿수 (예: 2면 100.00)
    },},
  { title: "납기일자", field: "M05DEVDATE", width: 120, hozAlign: "center" },
  { title: "이전납기", field: "", width: 120, hozAlign: "center" },
  { title: "납품장소", field: "DEVNAME", width: 120, hozAlign: "left" },
  { title: "호선명", field: "B05WORKNO", width: 120, hozAlign: "left" },
  { title: "엔진타입", field: "B05WORKNA", width: 120, hozAlign: "left" },
  { title: "HULL넘버", field: "B11HULL_NUM", width: 120, hozAlign: "left" },
  { title: "SHIP_YARD", field: "B11SHIP_YARD", width: 120, hozAlign: "left" },
  { title: "HeatNo", field: "M05HEATNO", width: 120, hozAlign: "left" },
  { title: "긴급", field: "M05CHKOPT", width: 70, hozAlign: "center" },
];

async function changeRadioGubun(){
  // 그리드를 지운다  
  arrSearchData.value = [];
  refUcGrid.value.clearData();
}

async function btnSearchClick() {
  // console.log("btnSearchClick", rdoSubTotalGubun.value.cd);

  const searchParams = {
    
    ID: "WERP\\T_MT05ORDR\\R008",
    Parameter: {
      "@FRDATE": dtStart.value.replaceAll("-", ""),
      "@TODATE": dtEnd.value.replaceAll("-", ""),
      "@CUSNM": userStore.userVendCd,
      "@DWGNO": txtDomyunNo.value,
      "@ORDGU": cboBaljuGubun.value.cd,
      "@SUBTOTALGBN": rdoSubTotalGubun.value.cd,
      "@PROGBN": rdoGubun.value.cd, // M / P
      "@TMGBN": cboGubun.value.cd, // 미납구분
      "@WORKNO": txtShipNo.value,
      "@PAGENO": 1,
      "@PAGEINROW": 10000,
      "@SIDX": null,
      "@SORD": null,
      "@CURPAGE": null,
      "@MAXPAGE": null,
      "@TOTALCOUNT": null,
    },
  };

  const res = await apiExecuteDataSet(searchParams);
  // console.log("res", res._Result);

  arrSearchData.value = res._Result[0];
}

async function btnExcelClick() {
  // console.log("btnExcelClick");

  const searchParams = {
    
    ID: "WERP\\T_MT05ORDR\\R008",
    Parameter: {
      "@FRDATE": dtStart.value.replaceAll("-", ""),
      "@TODATE": dtEnd.value.replaceAll("-", ""),
      "@CUSNM": userStore.userVendCd,
      "@DWGNO": "",
      "@ORDGU": "",
      "@SUBTOTALGBN": rdoSubTotalGubun.value.cd,
      "@PROGBN": cboGubun.value.cd,
      "@TMGBN": "",
      "@WORKNO": "",
      "@PAGENO": 1,
      "@PAGEINROW": 10000,
      "@SIDX": null,
      "@SORD": null,
      "@CURPAGE": null,
      "@MAXPAGE": null,
      "@TOTALCOUNT": null,
    },
  };



  const res = await apiExecuteDataSet(searchParams);
  // console.log("res", res._Result);

  if (res._Result[0].length === 0) {
    notify({
      title: "실패",
      text: "조회된 데이터 건수가 없습니다.",
      type: "error",
    });
    return;
  }

  const templatePath = "/excel/주문일보.xlsx";
  const today = new Date();

  try {
    // 템플릿 파일 가져오기
    const response = await fetch(templatePath);
    const buffer = await response.arrayBuffer();

    // 워크북 로드
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    // 첫 번째 워크시트 선택
    const worksheet = workbook.getWorksheet(1);

    // 데이터 바인딩
    worksheet.getCell("A2").value = `발주일자 : ${
      dtStart.value.replaceAll("-", "").slice(0, 4) +
      "-" +
      dtStart.value.replaceAll("-", "").slice(4, 6) +
      "-" +
      dtStart.value.replaceAll("-", "").slice(6, 8)
    } ~ ${
      dtEnd.value.replaceAll("-", "").slice(0, 4) +
      "-" +
      dtEnd.value.replaceAll("-", "").slice(4, 6) +
      "-" +
      dtEnd.value.replaceAll("-", "").slice(6, 8)
    }`;
    worksheet.getCell("A3").value = `거래선 : ${userStore.userVendCd}`;
    worksheet.getCell("A3").value = `거래선 : ${
      userStore.userVendCd.substring(0, 3) +
      "-" +
      userStore.userVendCd.substring(4, 2) +
      "-" +
      userStore.userVendCd.substring(6)
    }`;

    worksheet.getCell("T2").value = `작성자 : ${userStore.userName}`;
    worksheet.getCell("T3").value = `출력일자 :  ${formatDate(
      today,
      "yyyy-MM-dd"
    )}`;

    // 테이블 데이터 바인딩
    const startRow = 6; // 데이터가 시작될 행 번호 (예: 6번째 행부터 시작)
    arrSearchData.value.forEach((item, index) => {
      // console.log("forEach", index, item);

      const row = worksheet.getRow(startRow + index);
      row.getCell(2).value = item.POS;
      row.getCell(3).value = item.M05SEQNO;
      row.getCell(4).value = item.M05MATNA;
      row.getCell(5).value = item.M05DWGNO;
      row.getCell(6).value = item.M05SIZE;
      row.getCell(7).value = item.M05MATL;
      row.getCell(8).value = item.M0MIPGQTY;
      row.getCell(9).value = item.M05DANGA;
      row.getCell(10).value = item.M05AMOUNT;
      row.getCell(11).value = item.M05DEVDATE;
      //row.getCell(12).value = item.;
      row.getCell(13).value = item.DEVNAME;
      row.getCell(14).value = item.B05WORKNO;
      row.getCell(15).value = item.B05WORKNA;
      row.getCell(16).value = item.B11HULL_NUM;
      row.getCell(17).value = item.B11SHIP_YARD;
      row.getCell(18).value = item.M05HEATNO;
      row.getCell(19).value = item.M05CHKOPT;
      row.getCell(20).value = item.M05MATCD;
    });

    // 합계 데이터 바인딩
    // worksheet.getCell('D' + (startRow + dataToBind.salesData.length)).value = dataToBind.totalSales;

    // 변경된 워크북을 버퍼로 변환
    const excelBuffer = await workbook.xlsx.writeBuffer();

    // 파일을 Blob으로 만들고 다운로드
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `주문일보_${formatDate(today, "yyyyMMdd")}.xlsx`);

    notify({
      title: "성공",
      text: "엑셀 다운로드가 완료되었습니다.",
      type: "success",
    });
  } catch (error) {
    // console.error("엑셀 다운로드 중 오류 발생:", error);

    notify({
      title: "실패",
      text: "엑셀 다운로드에 실패했습니다." + error,
      type: "error",
    });
  }
}

//일보출력
async function btnIlboClick() {
  const searchParams = {
    
    ID: "W000\\W000\\R-OCM\\WY01PSR",
    Parameter: {
      "@CUSNO": userStore.userVendCd,
      "@F_CD": dtStart.value.replaceAll("-", ""),
      "@T_CD": dtEnd.value.replaceAll("-", ""),
      "@GBN": rdoGubun.value.cd === "M" ? "1" : "2",
    },
  };

  const exportParams = {
    title: "주문일보",
    //width: 1100,
    //height: 900,
  };

  await apiExecuteReport(searchParams, exportParams);
}

let printPopupWin = null;

//자재발주서출력
async function btnMBClick() {
  // 그리드에서 체크/선택된 데이터 수집
  let items = [];
  if (selectedRows.value && selectedRows.value.length > 0) {
    items = selectedRows.value;
  } else if (arrSearchData.value && arrSearchData.value.length > 0) {
    items = arrSearchData.value.filter((row) => row.isCheck);
  }

  // 중복 POS 제거 및 최대 30개 추출
  const uniqueItems = [];
  const seenPos = new Set();
  for (const item of items) {
    if (item && item.POS && !seenPos.has(item.POS)) {
      seenPos.add(item.POS);
      uniqueItems.push({
        pos: item.POS,
        heatNo: item.M05HEATNO || "",
      });
      if (uniqueItems.length >= 30) break;
    }
  }

  const gbn = rdoGubun.value.cd || "M";
  const timestamp = Date.now();

  // localStorage에 저장 (창 간 storage 이벤트 트리거)
  localStorage.setItem(
    "print_order_items",
    JSON.stringify({ items: uniqueItems, gbn, timestamp })
  );

  const width = 1050;
  const height = 620;
  const left = Math.max(0, (window.screen.width - width) / 2);
  const top = Math.max(0, (window.screen.height - height) / 2);
  const windowFeatures = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=no,toolbar=no,menubar=no,location=no`;

  // 팝업 열기 (timestamp 파라미터를 붙여 기존 창이 열려있어도 라우터 갱신 유도)
  printPopupWin = window.open(
    `/POPUP/print?gbn=${gbn}&t=${timestamp}`,
    "PrintMBWindow",
    windowFeatures
  );

  // 이미 열려있는 팝업창인 경우 postMessage로 데이터 즉시 반영 및 포커스
  if (printPopupWin) {
    printPopupWin.focus();
    printPopupWin.postMessage(
      {
        type: "UPDATE_PRINT_DATA",
        items: uniqueItems,
        gbn: gbn,
      },
      "*"
    );
  }
}

</script>
